import React from 'react';
import Strings from '../../i18n';

const sb600 = require('../../assets/location/icons-applications/sb600.png');

export const itemsApplications: {
  icon: React.ReactNode;
  text: string;
  url: string;
  disabled?: boolean;
}[] = [
  {
    icon: <img src={sb600} alt={Strings.applications.menu.sb600} width="100" />,
    text: Strings.applications.menu.sb600,
    url: '#',
    disabled: true
  }
];
